module.exports = __webpack_public_path__ + "static/media/MEPC-269(68).8bc98c92.pdf";